import loginMiddleware from './LoginScreen/LoginStore/loginMiddleware';

export const middlewares: any[] = [];

middlewares.push(loginMiddleware);
